import { ComponentProps } from "react";
import * as S from "./styles";
import { Input } from "../../Atoms/Inputs/Input";
import { SimpleSelect } from "../../Atoms/Selects/SimpleSelect";
import { Button } from "../../Atoms/Button";
import { useFormCollaboratorRegister } from "./useFormCollaboratorRegister";
import { ISelectOptions } from "../../../types/inputs";
import { IColaboradorFormRHF } from "../../../types/colaborador";
import { MessageErroForm } from "../../Atoms/MessageErroForm";

interface IFormCollaboratorRegisterProps extends ComponentProps<"form"> {
  submitForm: (data: IColaboradorFormRHF) => void;
}

export const FormCollaboratorRegister = ({
  submitForm,
  ...rest
}: IFormCollaboratorRegisterProps) => {
  const {
    control,
    handleSubmit,
    perfis,
    register,
    tipoOptions,
    Controller,
    errors,
    deliverys,
    lojas,
  } = useFormCollaboratorRegister();

  return (
    <S.MyFormCollaboratorRegister {...rest} onSubmit={handleSubmit(submitForm)}>
      <div>
        <Input
          data-error={!!errors?.nome?.message}
          id={"name"}
          {...register("nome")}
          label="Nome"
          required
        />
        {errors?.nome && (
          <MessageErroForm>{errors?.nome?.message}</MessageErroForm>
        )}
      </div>
      <div>
        <Input
          data-error={!!errors?.cpf?.message}
          maxLength={14}
          id={"cpf"}
          {...register("cpf")}
          label="CPF"
          required
        />
        {errors?.cpf && (
          <MessageErroForm>{errors?.cpf?.message}</MessageErroForm>
        )}
      </div>
      <div>
        <Input
          data-error={!!errors?.email?.message}
          id="email"
          {...register("email")}
          label="E-mail"
        />
        {errors?.email && (
          <MessageErroForm>{errors?.email?.message}</MessageErroForm>
        )}
      </div>
      <div>
        <Controller
          control={control}
          name="tipo"
          render={({ field: { onChange, value } }) => (
            <SimpleSelect
              options={tipoOptions}
              required
              data-error={!!errors?.tipo?.message}
              label="Tipo"
              onChange={(e: ISelectOptions) => {
                onChange(e?.value);
              }}
              value={tipoOptions.find((e) => e.value === value) || null}
            />
          )}
        />
        {errors?.tipo && (
          <MessageErroForm>{errors?.tipo?.message}</MessageErroForm>
        )}
      </div>
      <div>
        <Input
          data-error={!!errors?.telefone?.message}
          id="telefone"
          {...register("telefone")}
          maxLength={15}
          label="Telefone"
          required
        />
        {errors?.telefone && (
          <MessageErroForm>{errors?.telefone?.message}</MessageErroForm>
        )}
      </div>
      <div>
        <Controller
          control={control}
          name="perfis"
          render={({ field: { onChange } }) => (
            <SimpleSelect
              data-error={!!errors?.perfis?.message}
              options={perfis}
              required
              isMulti
              label="Perfil"
              onChange={(e: ISelectOptions) => {
                onChange(e);
              }}
            />
          )}
        />
        {errors?.perfis && (
          <MessageErroForm>{errors?.perfis?.message}</MessageErroForm>
        )}
      </div>

      <div>
        <Controller
          control={control}
          name="uuidLoja"
          render={({ field: { onChange, value } }) => (
            <SimpleSelect
              isClearable
              data-error={!!errors?.uuidLoja?.message}
              options={lojas}
              value={lojas.find((e) => e.value === value) || null}
              label="Unidade Loja"
              onChange={(e: ISelectOptions) => {
                onChange(e?.value);
              }}
            />
          )}
        />
      </div>

      <div>
        <Controller
          control={control}
          name="uuidDelivery"
          render={({ field: { onChange, value } }) => (
            <SimpleSelect
              isClearable
              value={deliverys.find((e) => e.value === value) || null}
              data-error={!!errors?.uuidDelivery?.message}
              options={deliverys}
              label="Unidade Delivery"
              onChange={(e: ISelectOptions) => {
                onChange(e?.value);
              }}
            />
          )}
        />
      </div>
      <div>
        <Button>Salvar</Button>
      </div>
    </S.MyFormCollaboratorRegister>
  );
};
